import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Component to handle dynamic CSS loading
const DynamicCssLoader: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Remove any previously loaded page-specific CSS
    const existingPageCss = document.querySelector("link[data-page-specific]");
    if (existingPageCss) {
      document.head.removeChild(existingPageCss);
    }

    // Determine which CSS to load based on the current route
    let cssPath = "";
    const path = location.pathname;

    if (path === "/" || path === "/index.html") {
      cssPath = "/css/pages/home.css";
    } else if (path.includes("/about")) {
      cssPath = "/css/pages/about.css";
    } else if (path.includes("/book-demo") || path.includes("/demo")) {
      cssPath = "/css/pages/book-demo.css";
    } else if (path.includes("/thank-you")) {
      cssPath = "/css/pages/thank-you.css";
    }

    // If a CSS path is determined, load it
    if (cssPath) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = cssPath;
      link.setAttribute("data-page-specific", "true");
      document.head.appendChild(link);
    }
  }, [location]);

  return null; // This component doesn't render anything
};

export default DynamicCssLoader;
